export default __webpack_public_path__ + "static/media/ingress_controller.62a3fc37.svg";